import React, { useMemo, useState } from 'react';
import { ActivityIndicator, Image, ImageStyle, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { useStyles } from 'react-native-unistyles';

interface Props {
    imageUrl: string;
    style?: StyleProp<ImageStyle>;
    viewStyle?: StyleProp<ViewStyle>;
    onLoadStart?: () => void;
    onLoadEnd?: () => void;
    onLoad?: () => void;
}

export function MyImage({ imageUrl, style, viewStyle, onLoad, onLoadEnd, onLoadStart }: Props) {
    const { theme } = useStyles();

    const [imageLoading, setImageLoading] = useState(false);
    const flatStyle = StyleSheet.flatten(style);
    const width = flatStyle?.width || 360;
    const height = flatStyle?.height || 360;

    const memorizedImage = useMemo(() => (
        <Image
            style={[
                {
                    width: 360,
                    height: 360,
                    resizeMode: 'cover',
                    borderRadius: 5,
                    overflow: 'hidden'
                }, style
            ]}
            source={{ uri: imageUrl }}
            onLoadStart={() => {
                onLoadStart?.();
                setImageLoading(true);
            }}
            onLoadEnd={() => {
                onLoadEnd?.();
                setImageLoading(false);
            }}
            onLoad={() => {
                onLoad?.();
                setImageLoading(false);
            }}
        />
    ), [imageUrl]);

    return (
        <View style={[{ width, height, justifyContent: 'center', alignItems: 'center' }, viewStyle]}>
            {imageLoading && (
                <ActivityIndicator
                    style={StyleSheet.absoluteFill}
                    size="large"
                    color={theme.colors.loadingColor}
                />
            )}
            <View style={imageLoading ? { opacity: 0 } : { opacity: 1 }}>
                {memorizedImage}
            </View>
        </View>
    );
}
